import { render, staticRenderFns } from "./addresses_contacts.vue?vue&type=template&id=2af0d781"
import script from "./addresses_contacts.vue?vue&type=script&lang=js"
export * from "./addresses_contacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports